(() => {
  function init() {
    const grid = document.querySelector('.comparison-table__grid');
    if (!grid) return;
    const columns = [...grid.querySelectorAll('.comparison-table__column')];
    const titles = columns.map(column => column.querySelector('.comparison-table__column-title'));
    const rows = columns.map(column => [...column.querySelectorAll('.comparison-table__feature')]);
    let frame;
    function fit() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const groups = [titles, ...Array.from({ length: Math.max(...rows.map(list => list.length)) }, (_, i) => rows.map(list => list[i]).filter(Boolean))];
        groups.forEach(group => group.forEach(element => {
          element.style.height = 'auto';
          element.style.maxHeight = 'none';
        }));
        titles.forEach(title => { title.style.setProperty('margin-bottom', '0px', 'important'); });
        const heights = groups.map(group => Math.max(...group.map(element => element.getBoundingClientRect().height)));
        groups.forEach((group, i) => group.forEach(element => { element.style.height = `${heights[i]}px`; }));
      });
    }
    new ResizeObserver(fit).observe(grid);
    grid.querySelectorAll('img').forEach(image => image.addEventListener('load', fit));
    document.fonts.ready.then(fit);
    window.addEventListener('resize', fit);
    fit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
